import React,{useState,useEffect} from 'react'
import Image from 'next/image';
const ProducthomeBanner = ({page,bannertext,ban1x,ban2x,ban360,bantab,banalt}) => {
    const [pageData, setPageData] = useState({});
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await fetch('/data/data.json');
          const data = await response.json();
          setPageData(data);
              //  console.log(data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
  
      fetchData();
    }, []);
  
    // Accessing the 'home_page_title' for the selected language
    const ban1_alt = pageData[page]?.ban1_alt || '';
  
    return (
      <picture className='relative w-full  flex flex-col justify-center items-center    lg:h-auto sm:mt-14 md:mt-14 lg:mt-0 h-auto'>
        <source media="(max-width: 600px)" srcSet={ban360.src} />
   {/* Tablet (426px to 899px) */}
   <source media="(min-width: 601px) and (max-width: 900px)" srcSet={bantab.src} />
  <source media="(min-width: 901px)" srcSet={`${ban2x.src} 1x, ${ban2x.src} 2x`} />
      {/* <source media="(max-width: 425px)" srcSet={ban360.src} />
      <source media="(min-width: 426px)" srcSet={`${ban2x.src} 1x, ${ban2x.src} 2x`} /> */}
      <img
        src={ban2x.src}
        alt={banalt}
        width={3840}
        height={900}
        className='block w-full  lg:h-auto object-cover object-center'
      />
    </picture>

      // <div className='relative w-full flex flex-col justify-center items-center  sm-small:h-[30vh] sm:h-[30vh] md-small:h-[30vh] md:h-[30vh]  lg:h-auto  sm:mt-14 md:mt-14 lg:mt-0 '>
       
       
      //           <Image  src={ban2x} alt={banalt} 
      //          srcSet={`${ban1x} 1920w, ${ban2x} 3840w ${ban3x ? `, ${ban3x} 360w` : ''}`}
      //           className='block w-full sm-small:h-[30vh] sm:h-[30vh] md-small:h-[30vh] md:h-[30vh] lg:h-auto object-cover object-center'
      //           />
      //            <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-3xl  text-white uppercase font-semibold' style={{ fontFamily: 'cinzel, sans-serif' }}>
      //                   {bannertext}
      //       </div>
           
      // </div>
    )
}

export default ProducthomeBanner
